import { getLeftNavGroupFoldersStore } from '../store/store';

export function getAllFolderIdsForGroup(groupId: string): string[] {
    let groupFolderIds: string[] = [];
    const folderHierarchy = getLeftNavGroupFoldersStore().folderTable.get(groupId)?.folderHierarchy;

    if (folderHierarchy) {
        for (const groupFolderId of folderHierarchy.keys()) {
            groupFolderIds.push(groupFolderId);
        }
    }

    return groupFolderIds;
}
